module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"Creation data","source":"Source","creator":"Creator"},"et":{"title":"Creation data","source":"Source","creator":"Creator"},"ru":{"title":"Creation data","source":"Source","creator":"Creator"}}')
  delete Component.options._Ctor
}
